module.exports = __webpack_public_path__ + "7a105a7a2029fa5cffc20967c41cc71f.jpg";